import { useLocation, useNavigate } from "react-router-dom";

export const useNavigateToBoard = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return () => {
        const params = new URLSearchParams(location.search);
        params.delete('id');
        params.delete('tab');
        const basePath = location.pathname.substring(0, location.pathname.lastIndexOf('/'));
        const query = params.toString();

        navigate(`${basePath}${query ? `?${query}` : ''}`);
    };
};
